import { ReactNode } from "react";
import { CustomTypographyProps, Text } from "@asayinc/component-library";

interface Props extends CustomTypographyProps {
  children: ReactNode;
}

export const TextCell = ({ children, ...props }: Props) => (
  <Text
    variant="body3"
    align="left"
    sx={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
    {...props}
  >
    {children}
  </Text>
);
